import * as development from "./development";
import * as production from "./production";

export const variable = {
  development,
  production,
};
